import React, {useState, useEffect} from 'react';

import {Text} from '~/components/controls';
import PropTypes from 'prop-types';

const CountDownText = ({timeout, style, onTimeout}) => {
  const [seconds, setSeconds] = useState(timeout);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(seconds - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds]);

  useEffect(() => {
    if (onTimeout && seconds <= 0) {
      onTimeout();
    }
  }, [onTimeout, seconds]);

  return (
    <Text style={style}>
      {seconds} seconde{seconds === 1 ? '' : 'n'}
    </Text>
  );
};
CountDownText.propTypes = {
  timeout: PropTypes.any,
  style: PropTypes.any,
  onTimeout: PropTypes.any,
};


export default CountDownText;
